"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvenAdvisorGiftCardType = void 0;
var AvenAdvisorGiftCardType;
(function (AvenAdvisorGiftCardType) {
    AvenAdvisorGiftCardType["starbucksFiveDollar"] = "starbucks_five_dollars";
})(AvenAdvisorGiftCardType || (exports.AvenAdvisorGiftCardType = AvenAdvisorGiftCardType = {}));
